import React from 'react';
import {
    Modal,
    Header,
    Button,
    Icon,
    Message
} from 'semantic-ui-react';
import {Link} from 'react-router-dom';

const DeleteClaimModal = (props) => {
    const { 
        open,
        handleOpenDeleteDialog,
        transactionNo, 
        status,
        handleDeleteDecision,
        deleteThisClaim,
        claimTransactionNo,
        deleteThisClaimResult
    } = props;
    const ableToDelete = (status === 'Submitted' || status === 'PROCESSING') ? true : false;
    const deleteHeader = (transactionNo) ? `Delete Claim - ${transactionNo}` : `Delete Claim`
    const deleteSuccessfulMessage = () => {
        return (
            <Message positive>
                <Message.Header>
                    Claim was deleted successfully!
                </Message.Header>
                <p>
                    <Link to="/app/claimrecords">
                        Click here to go back to claim records page.
                    </Link>
                </p>
            </Message>
        );
    }
    const deleteErrorMessage = () => {
        return (
            <Message negative>
                <Message.Header>
                    Opps! Claim was not deleted successfully...
                </Message.Header>
                <p>
                    Please try again later.
                </p>
                <Button 
                    onClick={() => handleOpenDeleteDialog(false)}
                >
                    Go back to claim 
                </Button>
            </Message>
        );
    }
    return (
        <Modal 
            closeOnDimmerClick={false}
            trigger={
                <Button
                    negative
                    disabled={!ableToDelete}
                    onClick={() => handleOpenDeleteDialog(true)}
                >
                    <Icon name="delete" />
                    Delete this claim
                </Button>
            } 
            open={open}
            basic 
            size='small'
        >
            <Header icon='delete' content={deleteHeader} />
            <Modal.Content>
                <p>
                    Are you sure you want to delete this claim?
                </p>
            </Modal.Content>
            {
                (deleteThisClaimResult && deleteThisClaimResult === true && deleteThisClaim === true) ? deleteSuccessfulMessage() : ''
            }
            {
                (deleteThisClaimResult && deleteThisClaimResult === false && deleteThisClaim === true) ? deleteErrorMessage() : ''
            }
            <Modal.Actions>
                <Button
                    color='red'
                    onClick={() => handleOpenDeleteDialog(false)}
                    disabled={deleteThisClaim}
                >
                    <Icon name='remove' /> No
                </Button>
                <Button 
                    loading={deleteThisClaim}
                    color='green' 
                    onClick={() => handleDeleteDecision(claimTransactionNo)}
                    disabled={deleteThisClaim}
                >
                    <Icon name='checkmark' /> Yes
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default DeleteClaimModal;